export const formatPercentage = number => {
  return Intl.NumberFormat("pt-BR", {
    style: "percent",
    maximumFractionDigits: 2
  }).format(Number(number) / 100);
};

export const formatDate = date => new Date(date).toLocaleDateString("pt-BR");

export const formatDocument = value => {
  if (!value) return "-";

  const document = value.replace(/\D/g, "");

  if (document.length === 11) {
    return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  }

  return document.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
    "$1.$2.$3/$4-$5"
  );
};
